/**
 * api.loadmanager.cloud
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EmailStatusLMApi = 'WhiteList' | 'Existing' | 'BlackList';

export const EmailStatusLMApi = {
    WhiteList: 'WhiteList' as EmailStatusLMApi,
    Existing: 'Existing' as EmailStatusLMApi,
    BlackList: 'BlackList' as EmailStatusLMApi
};

